import { TriggerDefinitionDTO, RuleTriggerDTO } from '../types/dto';
import { apiOrchestrator } from 'services/apiService';

export type CreateTriggerRequest = {
  rule_id: number;
  trigger_def_id: number;
  trigger_config?: Record<string, any>;
};

export type UpdateTriggerRequest = {
  trigger_config?: Record<string, any>;
};

export const triggersApi = {
  // Trigger Definitions
  getTriggerDefinitions: async (): Promise<TriggerDefinitionDTO[]> => {
    console.log('🔍 Buscando definições de gatilhos...');
    const response = await apiOrchestrator.get<TriggerDefinitionDTO[]>(
      '/automations/trigger-definitions'
    );
    console.log('✅ Definições de gatilhos carregadas:', response.data);
    return response.data;
  },

  getTriggerDefinition: async (uuid: string): Promise<TriggerDefinitionDTO> => {
    console.log(`🔍 Buscando definição de gatilho: ${uuid}`);
    const response = await apiOrchestrator.get<TriggerDefinitionDTO>(
      `/automations/trigger-definitions/${uuid}`
    );
    console.log('✅ Definição de gatilho carregada:', response.data);
    console.log('🔍 condition_definitions:', response.data.condition_definitions);
    console.log('🔍 action_definitions:', response.data.action_definitions);

    // ✅ FALLBACK: Se backend não retornar, usar definições hardcoded
    if (!response.data.condition_definitions && response.data.event_type === 'form_submission') {
      console.warn(
        '⚠️ Backend retornou trigger SEM condition_definitions! Usando fallback hardcoded para form_submission'
      );
      response.data.condition_definitions = [
        {
          // ✅ Sem ID - backend vai inferir ou ignorar
          uuid: 'hardcoded-submission-value',
          key: 'submission.value',
          label: 'Valor digitado',
          supported_operators: ['equals', 'not_equals', 'contains', 'not_contains'],
          value_options: {
            field_types: ['text', 'textarea', 'tags', 'geo_state'],
            resource_type: 'form.form_field.value',
          },
        },
        {
          // ✅ Sem ID - backend vai inferir ou ignorar
          uuid: 'hardcoded-submission-option',
          key: 'submission.option_id',
          label: 'Opção selecionada',
          supported_operators: ['equals', 'not_equals', 'in', 'not_in'],
          value_options: {
            field_types: ['checkbox', 'dropdown'],
            resource_type: 'form.form_field.option.option_id',
          },
        },
      ];
    }

    if (!response.data.action_definitions) {
      console.warn('⚠️ Backend retornou trigger SEM action_definitions!');
    }

    return response.data;
  },

  // Rule Triggers
  createTrigger: async (data: CreateTriggerRequest): Promise<RuleTriggerDTO> => {
    console.log('🔍 === INÍCIO createTrigger ===');
    console.log('🔍 Dados do trigger:', data);

    try {
      const response = await apiOrchestrator.post<RuleTriggerDTO>('/automations/triggers', data);
      console.log('✅ Trigger criado com sucesso:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao criar trigger:', error);
      console.error('❌ Dados enviados:', data);
      throw error;
    }
  },

  updateTrigger: async (uuid: string, data: UpdateTriggerRequest): Promise<RuleTriggerDTO> => {
    console.log(`🔍 Atualizando trigger ${uuid}:`, data);

    try {
      const response = await apiOrchestrator.patch<RuleTriggerDTO>(
        `/automations/triggers/${uuid}`,
        data
      );
      console.log('✅ Trigger atualizado:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar trigger:', error);
      throw error;
    }
  },

  deleteTrigger: async (uuid: string): Promise<void> => {
    console.log(`🔍 Deletando trigger: ${uuid}`);
    await apiOrchestrator.delete(`/automations/triggers/${uuid}`);
    console.log('✅ Trigger deletado');
  },
};
